import React from "react"
import AdminPage from "../components/AdminPage/AdminPage"
import RoleGuard from "../components/Auth0/RoleGuard"

const Admin = () => (
  <RoleGuard allowedRoles={["Admin"]}>
    <div
      className="d-flex"
      style={{ width: "100%", height: "100vh" }}
    >
      <div className="flex-grow-1">
        <AdminPage />
      </div>
    </div>
  </RoleGuard>
)

export default Admin
